import React, {useContext, useState} from 'react';
import { Link } from "react-router-dom";
import { makeStyles, styled, useTheme } from '@material-ui/core/styles';
import Box from '@mui/material/Box';
import './header.scss';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import MuiAppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Button from "@material-ui/core/Button";
import TemporaryDrawer from "../Drawer";
import CssBaseline from '@material-ui/core/CssBaseline';
import {StoreContext} from "../../store/context";
import clsx from 'clsx';
import {withRouter} from "react-router-dom";
import {useViewport} from "../viewport";

const drawerWidth = 300;

const PermanentDrawerAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const PermanentDrawerMain = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: `-${drawerWidth}px`,
      ...(open && {
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
      }),
    }),
);

const TemporaryDrawerMain = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      flexGrow: 1,
      padding: theme.spacing(3),
    }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));


const Header = (props) => {
  const { actions, state } = useContext(StoreContext);
  const { toggleNavigationDrawer } = actions.generalActions;
  const { logout } = actions.authActions;
  const { showNavDrawer } = state.generalStates;
  const theme = useTheme();

  const { width } = useViewport();

  const handleLogout = () => {
    sessionStorage.clear();
    logout();
    props.history.push("/");
  }

  const renderPermanentDrawer = () => {
    return (<Box>
              <div className="header">
                <div className="header-container">
                  <CssBaseline/>
                  <TemporaryDrawer/>
                  <PermanentDrawerAppBar position="fixed" open={showNavDrawer}>
                    <Toolbar sx={{background: "#1776D1"}}>
                      {/*<IconButton edge="start" className="menuButton" color="inherit" aria-label="menu" onClick={() => {toggleNavigationDrawer(true)}}>*/}
                      {/*</IconButton>*/}
                      <div className="title">
                        Qin Management System
                      </div>
                      <Button style={{fontFamily: 'AxiataBold', color: "#FFFFFF"}} onClick={handleLogout} color="inherit" className="desc">Logout</Button>
                      <IconButton
                          color="inherit"
                          aria-label="open drawer"
                          edge="end"
                          onClick={() => toggleNavigationDrawer(!showNavDrawer)}
                          sx={{ ...(showNavDrawer && { display: 'none' })}}>
                        <MenuIcon sx={{color: "#FFFFFF"}} />
                      </IconButton>
                    </Toolbar>
                  </PermanentDrawerAppBar>
                </div>
                <PermanentDrawerMain open={showNavDrawer}>
                  <DrawerHeader />
                  <div>{props.children}</div>
                </PermanentDrawerMain>
              </div>
            </Box>)
  }

  const renderTemporaryDrawer = () => {
    return (<Box>
              <div className="header">
                <div className="header-container">
                  <CssBaseline/>
                  <TemporaryDrawer/>
                  <MuiAppBar position="fixed" open={showNavDrawer}>
                    <Toolbar sx={{background: "#1776D1"}}>
                      {/*<IconButton edge="start" className="menuButton" color="inherit" aria-label="menu" onClick={() => {toggleNavigationDrawer(true)}}>*/}
                      {/*</IconButton>*/}
                      <div className="title">
                        Qin Management System
                      </div>
                      <Button style={{fontFamily: 'AxiataBold', color: "#FFFFFF"}} onClick={handleLogout} color="inherit" className="desc">Logout</Button>
                      <IconButton
                          color="inherit"
                          aria-label="open drawer"
                          edge="end"
                          onClick={() => toggleNavigationDrawer(!showNavDrawer)}
                          sx={{ ...(showNavDrawer && { display: 'none' })}}>
                        <MenuIcon sx={{color: "#FFFFFF"}} />
                      </IconButton>
                    </Toolbar>
                  </MuiAppBar>
                </div>
                <TemporaryDrawerMain open={showNavDrawer}>
                  <DrawerHeader />
                  <div>{props.children}</div>
                </TemporaryDrawerMain>
              </div>
          </Box>)
  }

  return (width > 1000 ? renderPermanentDrawer() : renderTemporaryDrawer())
}

export default withRouter(Header)
